import CancelIcon from '@mui/icons-material/Cancel'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { SimpleFilterApi } from '@promoboxx/use-filter/dist/useSimpleFilter'
import I18n from 'i18n-js'
import { makeStyles } from 'tss-react/mui'

import MenuItemWithCheckbox from '@src/lib/MenuItemWithCheckbox'

import { DownloadblesFilters } from './Filters'
import { useAssetTags } from './useAssetTags'

const useStyles = makeStyles()((theme) => ({
  formControl: {
    'marginLeft': theme.spacing(2),
    '&:first-child': {
      marginLeft: theme.spacing(0),
    },
    'width': '100%',
    'maxWidth': '360px',
  },
  filterContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  chip: {
    marginRight: theme.spacing(1),
  },
}))

type LegacyFiltersProps = {
  filterApi: SimpleFilterApi<DownloadblesFilters>
}

const LegacyFilters: React.FC<React.PropsWithChildren<LegacyFiltersProps>> = ({
  filterApi,
}) => {
  const assetTags = useAssetTags()
  const { classes } = useStyles()

  const handleRemoveTag = (value: string): void => {
    const newTags = filterApi.filterInfo.filter.tags.filter(
      (tag) => tag !== value,
    )
    filterApi.updateFilter({ tags: newTags })
  }

  return (
    <div className={classes.filterContainer}>
      <TextField
        className={classes.formControl}
        value={filterApi.filterInfo.filter.search}
        onChange={(e) => filterApi.updateFilter({ search: e.target.value })}
        label={I18n.t('downloadables.search')}
        data-testid={'downloadablesSearchField'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {filterApi.filterInfo.filter.search.length > 0 && (
                <IconButton edge="end" size="large">
                  <CancelIcon
                    onClick={(e) => filterApi.updateFilter({ search: '' })}
                  />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
      <TextField
        className={classes.formControl}
        value={filterApi.filterInfo.filter.tags}
        onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
          filterApi.updateFilter({ tags: event.target.value as string[] })
        }}
        label={I18n.t('downloadables.filterByTags')}
        data-testid={'searchByTag'}
        SelectProps={{
          multiple: true,
          renderValue: () => (
            <div>
              {filterApi.filterInfo.filter.tags.map((value) => (
                <Chip
                  key={value}
                  label={value}
                  onMouseDown={(event) => {
                    event.stopPropagation()
                  }}
                  className={classes.chip}
                  onDelete={() => handleRemoveTag(value)}
                />
              ))}
            </div>
          ),
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
          },
        }}
        select
      >
        {assetTags.map((name) => (
          <MenuItemWithCheckbox
            key={name}
            value={name || ''}
            data-testid={`tagName: ${name}`}
          >
            {name}
          </MenuItemWithCheckbox>
        ))}
      </TextField>
    </div>
  )
}

export default LegacyFilters
